import tw from 'twin.macro';
import { Primary } from '../../../misc';

export const Container = tw.div`w-screen bg-white h-full flex flex-col justify-between lg:flex-row`;

// styles for the first column of the page
export const ColumnOne = tw.div`lg:w-1/2 items-center
 lg:pt-20 px-4 pt-10 flex-col lg:px-20 overflow-auto lg:overflow-hidden`;

export const ColumnOneContent = tw.div`lg:mt-32 2xl:mt-44 text-center`;

export const ContentTitle = tw.h1`
  lg:text-6xl text-4xl mt-4 capitalize font-semibold
`;

export const ContentSubTitle = tw.p`text-xl font-semibold lg:py-8 py-6`;

export const ContentCTOs = tw.div`text-white
 flex justify-center pb-6 lg:pb-2 flex-col lg:flex-row gap-1 lg:gap-8 2xl:gap-10`;

export const LoginCTO = tw(Primary)`my-3 lg:text-xl items-center justify-center flex text-lg`;

// styles for the second column of the page
export const ColumnTwo = tw.div`lg:w-1/2 hidden lg:block
 pt-12 pl-24 pr-10 flex-col justify-evenly items-stretch relative`;

export const ImageOne = tw.img`lg:w-64 h-64 2xl:h-80 2xl:w-80
 rounded-[3rem] bg-center object-cover`;

export const ImageTwo = tw.img`w-60 h-60 rounded-[2rem]  bg-center object-cover 
-mt-12 2xl:right-28 lg:right-10 absolute`;

export const ImageThree = tw.img`w-60 h-60 rounded-[3rem] 2xl:h-80 2xl:w-80 bg-center
 object-cover self-end justify-self-end absolute bottom-12`;

// Mobile Carousel
export const MobileViewCarousel = tw.div`lg:hidden pt-10 px-6`;
